export function getGroups(state) {
  return state.groups;
}

export function getGroupList(state) {
  return getGroups(state).list;
}

export function getDeletedGroup(state) {
  return getGroups(state).deleted;
}

export function getStudentsStagedForInvite(state) {
  return getGroups(state).studentsStagedForInvite
}

export function getMemberRecordById(group, memberIdIndex) {
  return group.memberRecords.get(group.memberIds.get(memberIdIndex))
}

export function getMemberInviteStatus(group, userId) {
  return group.memberRecords.get(userId).inviteStatus
}


export function getStudentsStagedForInviteByEmail(state, email) {
  const studentsStagedForInviteList = getStudentsStagedForInvite(state)
  const index = studentsStagedForInviteList.findIndex(student => student.email === email)
  if (index === -1) {
    return null
  }
  return studentsStagedForInviteList.get(index)
}


// WEBPACK FOOTER //
// ./src/core/groups/selectors.js